import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { ToastrService } from 'ngx-toastr';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';

import { ConfirmComponent } from '../../modals';
import { GroupsCommitteesService } from '../../services';

export interface GroupMembersModel {
    title: string;
    button: string;
    label: string;
    edit: boolean;
    committee_type: string;
    group_id: number;
    group_members: Array<any>;
    group: boolean;
}

@Component({
    selector: 'group-members',
    templateUrl: './group-members.html',
    styleUrls: ['./group-members.scss']
})

export class GroupMembersComponent extends DialogComponent<GroupMembersModel, any> implements GroupMembersModel, OnInit {
    title: string;
    button: string;
    label: string;
    edit: boolean;
    committee_type: string;
    group_id: number;
    group_members: Array<any>;
    group: boolean;

    data = [];
    filterQuery = '';
    rowsOnPage = 10;
    sortBy = 'name';
    sortOrder = 'asc';

    private searchForm: FormGroup;
    private search: AbstractControl;
    private members: AbstractControl;

    private filter_term: string;
    private committee_type_obj = {
        committee_type: ''
    }

    private members_arr = [];
    private dropdownSettings: IMultiSelectSettings = {
        enableSearch: false,
        checkedStyle: 'fontawesome',
        buttonClasses: 'btn btn-default btn-block',
        dynamicTitleMaxItems: 10,
        fixedTitle: true,
        closeOnClickOutside: false,
        selectionLimit: 1,
        autoUnselect: true,
        containerClasses: 'dropdown-members'
    };

    private myTexts: IMultiSelectTexts = {
        searchPlaceholder: 'Pronađi korisnika',
        searchEmptyResult: 'Nije pronađen niti jedan korisnik...',
        defaultTitle: 'Dodaj korisnika...',
    };

    private search_error_msg: boolean = false;
    private errorMsg: string = '';

    private dataToSend = {
        committee_organizer: true
    }

    private dataToSendFalse = {
        committee_organizer: false
    }

    constructor(
        dialogService: DialogService,
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private slimLoader: SlimLoadingBarService,
        private groupsCommitteesService: GroupsCommitteesService
    ) {
        super(dialogService);
    }

    // For datatables
    toInt(num: string) {
        return +num;
    }

    ngOnInit() {
        this.searchForm = this.formBuilder.group({
            search: [''],
            members: []
        });

        this.search = this.searchForm.controls['search'];

        this.searchForm.controls['members'].valueChanges.subscribe((value) => {
            if (value !== null) {
                if (value.length > 0) {
                    for (let i = 0; i < value.length; i++) {
                        this.add(value[i]);
                    }
                }
            }
        });

        if (this.group_members.length > 0) {
            if (this.edit !== undefined) {
                for (let i = 0; i < this.group_members.length; i++) {
                    this.group_members[i].member.edit = true;
                    if (this.group_members[i].committee_president === true || this.group_members[i].committee_organizer === true) {
                        this.group_members[i].member.class = true;
                    }
                    this.group_members[i].member.committee_president = this.group_members[i].committee_president;
                    this.group_members[i].member.committee_organizer = this.group_members[i].committee_organizer;
                    this.data.push(this.group_members[i].member);
                }
            } else {

                for (let i = 0; i < this.group_members.length; i++) {
                    this.group_members[i].member.committee_president = this.group_members[i].committee_president;
                    this.group_members[i].member.committee_organizer = this.group_members[i].committee_organizer;
                    this.data.push(this.group_members[i]);
                }
            }
        }

    }

    add(value) {
        this.searchForm.controls.members.reset();
        let found = this.data.some(function (el) {
            return el.id === value;
        });
        if (!found) {
            for (let i = 0; i < this.members_arr.length; i++) {
                if (this.members_arr[i].id === value) {
                    let activeModal = this.dialogService.addDialog(ConfirmComponent, {
                        title: 'Dodaj korisnika',
                        message: 'Jeste li sigurni da želite dodati ' + this.members_arr[i].first_name + ' ' + this.members_arr[i].last_name + ' ?',
                        button: 'Dodaj',
                    })
                        .subscribe((isConfirmed) => {
                            if (isConfirmed) {
                                // Add user to datatable
                                this.members_arr[i].edit = false;
                                this.data.push(this.members_arr[i]);
                                this.toastr.success("Uspješno ste dodali korisnika");
                            }
                        });
                }
            }
        } else {
            if (this.label === 'Članovi odbora') {
                this.toastr.error("Korisnik je već dodan kao član odbora!");
            } else {
                this.toastr.error("Korisnik je već dodan kao član grupe!");
            }
        }
    }

    searchUsers(term, committee_type_value) {
        this.filter_term = term;
        if (committee_type_value !== null) {
            this.committee_type_obj.committee_type = committee_type_value.toLowerCase();
        }
        this.groupsCommitteesService.getAllPartyMembers(this.filter_term, this.committee_type_obj).subscribe(
            response => {
                if (response.party_members.length > 0) {
                    this.search_error_msg = false;
                    for (let i = 0; i < response.party_members.length; i++) {
                        if (response.party_members[i].first_name) {
                            response.party_members[i].name = response.party_members[i].first_name + ' ' + response.party_members[i].last_name + ' - ' + response.party_members[i].email;
                        } else {
                            response.party_members[i].name = response.party_members[i].email;
                        }
                    }
                } else {
                    this.search_error_msg = true;
                }
                this.members_arr = response.party_members;
                this.slimLoader.complete();
            },
            error => {
                if (error.error_msg) {
                    this.toastr.error(error.error_msg);
                    this.errorMsg = error.error_msg;
                    this.slimLoader.complete();
                }
            },
        );
    }

    onDelete(user) {
        const activeModal = this.dialogService.addDialog(ConfirmComponent, {
            title: 'Izbriši korisnika',
            message: 'Jeste li sigurni da želite izbrisati ' + user.first_name + ' ' + user.last_name + ' ?',
            button: 'Izbriši',
        })
            .subscribe((isConfirmed) => {
                if (isConfirmed) {
                    let id = user.id;
                    const toDelete = new Set([id]);

                    // Remove user from datatable
                    this.data = this.data.filter(obj => !toDelete.has(obj.id));
                    this.toastr.success("Uspješno ste izbrisali korisnika");
                    this.searchForm.controls.members.reset();
                }
            });

    }

    putAsOrganizer(user) {
        if (user.class === true) {
            let activeModal = this.dialogService.addDialog(ConfirmComponent, {
                title: 'Ukloni kao organizatora',
                message: 'Jeste li sigurni da želite ' + user.first_name + ' ' + user.last_name + ' ukloniti kao organizatora?',
                button: 'Ukloni',
            })
                .subscribe((isConfirmed) => {
                    if (isConfirmed) {
                        this.groupsCommitteesService.putOrganizerRole(this.group_id, user.id, this.dataToSendFalse).subscribe(
                            response => {
                                delete user.class;
                                delete user.committee_organizer;
                                this.slimLoader.complete();
                                this.toastr.success(response.message);
                            },
                            error => {
                                if (error.error_msg) {
                                    this.toastr.error(error.error_msg);
                                    this.slimLoader.complete();
                                }
                            },
                        );
                    }
                });
        } else {
            let activeModal = this.dialogService.addDialog(ConfirmComponent, {
                title: 'Postavi kao organizatora',
                message: 'Jeste li sigurni da želite ' + user.first_name + ' ' + user.last_name + ' postaviti kao organizatora?',
                button: 'Postavi',
            })
                .subscribe((isConfirmed) => {
                    if (isConfirmed) {
                        this.groupsCommitteesService.putOrganizerRole(this.group_id, user.id, this.dataToSend).subscribe(
                            response => {
                                user.class = true;
                                user.committee_organizer = true;
                                this.slimLoader.complete();
                                this.toastr.success(response.message);
                            },
                            error => {
                                if (error.error_msg) {
                                    this.toastr.error(error.error_msg);
                                    this.slimLoader.complete();
                                }
                            },
                        );
                    }
                });
        }
    }

    confirm(data) {
        // we set dialog result as true on click on confirm button, 
        // then we can get dialog result from caller code
        this.result = data;
        this.close();
    }
}


// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/modals/group-members/group-members.component.ts